export const dosTheme = {
  primary: '#FFFFFF',
  primary_rgb: '255, 255, 255',
  secondary: '#3F40C7',
  secondary_rgb: '63, 64, 199',
  tertiary: '#FFB800',
  tertiary_rgb: '255, 184, 0',
  gradient_top: '#4155BF',
  gradient_bottom: '#3A00DE'
}

export const atariTheme = {
  primary: '#FFB800',
  primary_rgb: '255, 184, 0',
  secondary: '#000000',
  secondary_rgb: '0, 0, 0',
  tertiary: '#FFFFFF',
  tertiary_rgb: '255, 255, 255',
  gradient_top: '#000000',
  gradient_bottom: '#000000'
}
